export const StorageKeys = {
  BLUR: 'jitsu_customer_data_blur',
  BLUR_ADDRESS: 'jitsu_customer_address_blur',
};

export const storageRemove = (key) => {
  localStorage.removeItem(key);
};

export const storageClear = () => {
  localStorage.clear();
};

export const localStorageGet = (key) => {
  return JSON.parse(localStorage.getItem(key) || '{}');
};

export const localStorageSet = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const sessionStorageGet = (key) => {
  return JSON.parse(sessionStorage.getItem(key) || '{}');
};

export const sessionStorageSet = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};
